import { render, staticRenderFns } from "./downloadzone.vue?vue&type=template&id=7c44d03a&scoped=true&"
import script from "./downloadzone.vue?vue&type=script&lang=js&"
export * from "./downloadzone.vue?vue&type=script&lang=js&"
import style0 from "./downloadzone.vue?vue&type=style&index=0&id=7c44d03a&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44d03a",
  null
  
)

export default component.exports